import React, { useEffect, useState, useCallback, useRef } from 'react'
import Chats from './chats'
import { COMMON_URL, CONTENT_URL } from '../utils/ApiConstants';
import Assistant from '../assets/icons/AI/bot.png';
import MicOn from '../assets/icons/AI/mic_on.svg';
import MicOff from '../assets/icons/AI/mic_off.svg';
import Send from '../assets/icons/AI/send.svg';
import MicOffFill from '../assets/icons/AI/mic_off_fill.svg';
import MicOnFill from '../assets/icons/AI/mic_on_fill.svg';
import MicDisabled from '../assets/icons/AI/mic_disabled.svg';
import { Toast } from 'react-bootstrap';

const content = {
  "en": {
    type: "Tap on the mic to speak or type your message",
    stopSpeaking: "Stop speaking",
    tapToSpeak: "Tap to speak",
    orTypeYourMessageBelow: "or type your message below",
    thanksForRequestingCallback: "Thank you! Your callback request has been submitted successfully. Our team will contact you soon.",
    errorProcessingRequest: "Sorry, there was an error processing your request. Please try again later.",
    breasyIsListening: "Breasy is listening!",
    speechErrorPrompt: "Didn't catch that. Tap the mic and try again."
  },
  "hi": {
    type: "अपना संदेश यहां टाइप करें...",
    stopSpeaking: "बात भरना बंद करें",
    tapToSpeak: "बात भरना शुरू करें",
    orTypeYourMessageBelow: "या अपना संदेश नीचे टाइप करें",
    thanksForRequestingCallback: "धन्यवाद! आपका कॉलबैक अनुरोध सफलतापूर्वक सबमिट किया गया है। हमारी टीम जल्द ही आपसे संपर्क करेगी।",
    errorProcessingRequest: "क्षमा करें, आपका अनुरोध प्रस्तुत करने में एक त्रुटि हो गई है। कृपया पुनः प्रयास करें।",
    speechErrorPrompt: "समझ नहीं पाया। कृपया फिर से बोलने के लिए माइक टैप करें।"
  }
}

// Static access token for fallback
const STATIC_ACCESS_TOKEN = 'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbiI6IkFRSUNBSGpNMGFmZUVxcU5lMWs0YzR6MXp5QTBYeERaZnhJUjYxdnh4R0M0Sy8ybndBR0twVk1sSXdDV2dCRnQzVmwyL3RVc0FBQUE0ekNCNEFZSktvWklodmNOQVFjR29JSFNNSUhQQWdFQU1JSEpCZ2txaGtpRzl3MEJCd0V3SGdZSllJWklBV1VEQkFFdU1CRUVEQ2RJRXlVTUIzaWVxTmxuSlFJQkVJQ0JtMTYwUlFXTWNrQU5Ja2VXNDZYUFFwOU5VMFd1aTNGR2U2UEtNZ0p4VWdUQnFKZy9zZW1BMnpPVkVLSlhkL0V3bmxna2lWNjRhSFB4NkJoWGFyS0I1RlJFRWVTK0FqUDJEZEVsTzl4RlFONC9GN1ljZFhpb3hZWjJVNk1PY1ZWM1NxRFFocXhkZWhyaGtCTTk0VVFVclRzb2MxVTE1cGw3SmltUmJreW9VVFlXby9kT0RlRUF1QVhhSmQ4ckVlQVhTK3hndFNEU3FpaHllemZjIiwiaWF0IjoxNzYxODE3NDgyLCJleHAiOjE3NzA0NTc0ODJ9.nmrAE26iBCnI-IhUI2osWvf7w-fJjRtWdTyuY6UDlYM';

// const STATIC_ACCESS_TOKEN = "eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJ0b2tlbiI6IkFRSUNBSGpNMGFmZUVxcU5lMWs0YzR6MXp5QTBYeERaZnhJUjYxdnh4R0M0Sy8ybndBSG5ySEFqUkh3N21ua0tkcnViM0h2UEFBQUE0ekNCNEFZSktvWklodmNOQVFjR29JSFNNSUhQQWdFQU1JSEpCZ2txaGtpRzl3MEJCd0V3SGdZSllJWklBV1VEQkFFdU1CRUVERTBLNDVsdGtwcFl2RE5BdHdJQkVJQ0JteElsNnBZRlEyUjRVVjk1N1kzR3IzbTc1RHZxQXlPU3B6MlR2TTduQmY0aERwQlZUcjdET0xzWjREL2grMnlqTWN6M0tIN2hCblJBbzd4T3RUVm5vLzFycVpYMlFOYmwybEdKZ2t2NjVxN0w5SXpENmRnWHpmYXJtM2k2cVc1Z2hPUU13a2d4MUN1V1BYeTJtUFZWMllnVUx2S09IV3d3UTY4UVlzbVI5dFZEa2NjdWFLVlVmMDhoY3hjcTdkb1plMDRwSEhGMUtmVmN4a2lwIiwiaWF0IjoxNzYxNjQ1MTM3LCJleHAiOjE3NzAyODUxMzd9.SZIqybNWeyh5ocTAiqQIMfQAZzm_ZFGsyTSo3IXTYbE"

const getAccessTokenFromURL = () => {
  if (typeof window === 'undefined') {
    return '';
  }
  try {
    const params = new URLSearchParams(window.location.search || '');
    return params.get('access_token') || '';
  } catch (error) {
    console.warn('Failed to read access_token from URL:', error);
    return '';
  }
};

// Function to send TTS message to app
const sendTTSMessage = (text, action = 'speak') => {
  if (window?.ReactNativeWebView && text) {
    const reactNativePayload = {
      type: "TTS_MESSAGE",
      key: action === 'speak' ? 211 : 212, // 211 for speak, 212 for stop
      data: {
        text: text
      }
    };
    window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
    console.log(`🔊 TTS ${action}:`, text);
  }
};

// Function to convert the last message into a single string of text
const convertLastMessageToText = (chatsArray) => {
  if (!chatsArray || chatsArray.length === 0) {
    return '';
  }

  const lastMessage = chatsArray[chatsArray.length - 1];

  // Handle the actual data structure from your API
  const messages = lastMessage.data || lastMessage.messages;

  if (!messages) {
    return '';
  }

  // If messages is an array, process each item
  if (Array.isArray(messages)) {
    return messages.map(item => {
      if (!item || typeof item !== 'object') {
        return '';
      }

      switch (item.type) {
        case 'text':
          return item.text || '';
        case 'card':
          return `${item.title || ''} (${item.badge || ''}): ${item.description || ''}`;
        case 'single-choice':
          const options = item.options ? item.options.map(opt => opt.label || '').join(', ') : '';
          return `${item.title || ''} Options: ${options}`;
        case 'lcp-card':
          return `${item.title || ''}: ${item.description || ''}`;
        case 'redirection-card':
          return `${item.label || ''}: ${item.description || ''}`;
        case 'event-card':
          const ctaTexts = item.cta ? item.cta.map(cta => cta.text || '').join(', ') : '';
          return `${item.title || ''} (${item.badge || ''}): ${item.description || ''}. Actions: ${ctaTexts}`;
        default:
          return '';
      }
    }).filter(text => text.trim() !== '').join(' ');
  }

  // If messages is a single object
  if (typeof messages === 'object' && messages.type) {
    switch (messages.type) {
      case 'text':
        return messages.text || '';
      case 'card':
        return `${messages.title || ''} (${messages.badge || ''}): ${messages.description || ''}`;
      case 'single-choice':
        const options = messages.options ? messages.options.map(opt => opt.label || '').join(', ') : '';
        return `${messages.title || ''} Options: ${options}`;
      case 'lcp-card':
        return `${messages.title || ''}: ${messages.description || ''}`;
      case 'redirection-card':
        return `${messages.label || ''}: ${messages.description || ''}`;
      case 'event-card':
        const ctaTexts = messages.cta ? messages.cta.map(cta => cta.text || '').join(', ') : '';
        return `${messages.title || ''} (${messages.badge || ''}): ${messages.description || ''}. Actions: ${ctaTexts}`;
      default:
        return '';
    }
  }

  return '';
};

// API call function for chat AI bot
const sendMessageToChatBot = async (accessToken, message, uuid, input_source) => {
  try {
    const response = await fetch(`${COMMON_URL}/v1/ai-services/chat-ai-bot`, {
      method: 'Post',
      headers: {
        'Content-Type': 'application/json',
        'accesstoken': accessToken || ''
      },
      body: JSON.stringify({
        message_id: uuid,
        user_message: message,
        input_source: input_source
      })
    });

    // Explicitly throw for non-2xx so callers hit catch (e.g., 401)
    if (!response.ok) {
      let errorPayload = null;
      let errorBody = '';
      try {
        errorPayload = await response.json();
      } catch (_) {
        try { errorBody = await response.text(); } catch (_) { errorBody = ''; }
      }
      const error = new Error(`HTTP ${response.status}`);
      error.status = response.status;
      error.body = errorBody;
      error.payload = errorPayload;
      throw error;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error sending message to chat bot:', error);
    throw error;
  }
};

// API call function for LCP callback request
const sendLCPCallbackRequest = async (accessToken, callbackNumber = null) => {
  try {
    const response = await fetch(`${CONTENT_URL}/api/v4/google-sheet`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json, text/plain, */*',
        'Content-Type': 'application/json',
        'timestamp': Date.now().toString(),
        'accesstoken': accessToken || '',
        'Access-Control-Allow-Origin': '*'
      },
      body: JSON.stringify({
        request_type: "request_call_back",
        landing_page_type: 0,
        callback_number: callbackNumber,
        source: 'ai_chatbot'
      })
    });

    if (!response.ok) {
      const error = new Error(`HTTP ${response.status}`);
      error.status = response.status;
      throw error;
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error('Error sending LCP callback request:', error);
    throw error;
  }
};

const ChatBot = () => {
  const [message, setMessage] = useState('');
  const [uuid, setUuid] = useState('');
  const [accessToken, setAccessToken] = useState('');
  const [langCode, setLangCode] = useState('en');
  const [response, setResponse] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isFromSpeech, setIsFromSpeech] = useState(false);
  const [lastInputSource, setLastInputSource] = useState('text');
  const [isRecording, setIsRecording] = useState(false);
  const [userData, setUserData] = useState(null);
  const [isFocused, setIsFocused] = useState(false);
  const [isMicLocked, setIsMicLocked] = useState(false);
  const ttsTimeoutRef = useRef(null);
  const micUnlockTimeoutRef = useRef(null);
  const profileRetryRef = useRef(0);
  const textareaRef = useRef(null);
  const initialMessageTriggeredRef = useRef(false);
  const isVisibleRef = useRef(true);
  const speechBaseTextRef = useRef('');
  const latestMessageRef = useRef('');
  const buildSpeechText = useCallback((incomingText) => {
    const base = (speechBaseTextRef.current || '').trim();
    const addition = (incomingText || '').trim();

    if (!addition) {
      return base;
    }

    if (!base) {
      return addition;
    }

    if (addition.toLowerCase().startsWith(base.toLowerCase())) {
      return addition;
    }

    return `${base} ${addition}`.replace(/\s+/g, ' ').trim();
  }, []);


  const requestProfileData = useCallback(() => {
    if (window?.ReactNativeWebView) {
      const payload = { type: 'REQUEST_PROFILE_DATA', key: 211 };
      window.ReactNativeWebView.postMessage(JSON.stringify(payload));
    }
  }, []);

  useEffect(() => {
    const tokenFromURL = getAccessTokenFromURL();
    if (tokenFromURL) {
      setAccessToken(tokenFromURL);
    }
  }, []);

  const adjustTextareaHeight = useCallback(() => {
    const textarea = textareaRef.current;
    if (textarea) {
      textarea.style.height = 'auto';
      const scrollHeight = textarea.scrollHeight;
      const lineHeight = 20; // Approximate line height for text-xs
      const maxHeight = lineHeight * 3 + 12; // 3 rows + padding (py-4 = 16px top + 16px bottom)
      textarea.style.height = `${Math.min(scrollHeight, maxHeight)}px`;
      textarea.style.overflowY = scrollHeight > maxHeight ? 'auto' : 'hidden';
    }
  }, []);

  const releaseMicLockWithDelay = useCallback(() => {
    if (micUnlockTimeoutRef.current) {
      clearTimeout(micUnlockTimeoutRef.current);
    }
    setIsMicLocked(true);
    micUnlockTimeoutRef.current = setTimeout(() => {
      setIsMicLocked(false);
      micUnlockTimeoutRef.current = null;
    }, 2000);
  }, []);

  const StopListening = useCallback(() => {
    console.log("🛑 Stopping speech recognition...");

    // Check if we're in a React Native WebView
    if (window?.ReactNativeWebView) {
      // Stop any ongoing TTS first
      const ttsStopPayload = {
        type: "TTS_MESSAGE",
        key: 212, // STOP_TTS
        data: { text: "" }
      };
      window?.ReactNativeWebView?.postMessage(JSON.stringify(ttsStopPayload));

      // Send message to React Native to stop speech recognition
      const reactNativePayload = {
        key: 210, // STOP_VOICE
        type: 'STOP_VOICE'
      };
      window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
      setIsRecording(false);
      setIsFromSpeech(false);
      releaseMicLockWithDelay();
    } else {
      console.log("❌ Not in React Native WebView - speech recognition not available");
      releaseMicLockWithDelay();
    }
  }, [releaseMicLockWithDelay]);

  const StartListening = () => {
    console.log("🎤 Starting speech recognition...");

    if (isMicLocked && !isRecording) {
      console.log("⏳ Mic action ignored because previous request is still pending.");
      return;
    }

    // Check if we're in a React Native WebView
    if (window?.ReactNativeWebView) {
      speechBaseTextRef.current = message || '';
      // Stop any ongoing TTS first
      const ttsStopPayload = {
        type: "TTS_MESSAGE",
        key: 212, // STOP_TTS
        data: { text: "" }
      };
      window?.ReactNativeWebView?.postMessage(JSON.stringify(ttsStopPayload));

      // Send message to React Native to start speech recognition
      const reactNativePayload = {
        key: 209, // START_VOICE
        type: 'START_VOICE'
      };
      window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
      setIsFromSpeech(true);
      setIsRecording(true);
      setIsMicLocked(true);
    } else {
      console.log("❌ Not in React Native WebView - speech recognition not available");
      setIsMicLocked(false);
    }
  };

  const handleSendMessage = useCallback(async (messageText = message, isSingleChoice = false, chatId = null, inputSource = 'text') => {
    console.log("🚀 ~ ChatBot ~ messageText:", messageText, "isSingleChoice:", isSingleChoice, "chatId:", chatId, "inputSource:", inputSource);
    if (!messageText || !messageText.trim()) return;

    const currentMessage = messageText;
    setLastInputSource(inputSource);

    if (!isSingleChoice) {
      const userMessage = {
        role: 'user',
        data: {
          type: 'text',
          text: messageText,
        },
      };
      setResponse(prevResponse => [...prevResponse, userMessage]);
      // Stop microphone if it was from speech-to-text
      StopListening();
      // Reset textarea height after clearing message
      setTimeout(() => adjustTextareaHeight(), 0);

      setIsFromSpeech(false);

      setTimeout(() => setMessage(''), 100);
    }

    // Stop any ongoing TTS when sending a new message
    if (window?.ReactNativeWebView) {
      const ttsStopPayload = {
        type: "TTS_MESSAGE",
        key: 212, // STOP_TTS
        data: { text: "" }
      };
      window?.ReactNativeWebView?.postMessage(JSON.stringify(ttsStopPayload));
    }

    setIsLoading(true);

    try {
      const messageId = chatId || uuid;
      const result = await sendMessageToChatBot(accessToken, currentMessage, messageId, inputSource);
      if (result?.data) {
        setResponse(prevResponse => [...prevResponse, result.data]);
      } else {
        // If API returned an error-shaped payload, echo entire response
        setResponse(prevResponse => [...prevResponse, {
          role: 'assistant',
          data: {
            type: 'error',
            text: JSON.stringify(result)
          }
        }]);
      }
      setIsLoading(false);
    } catch (error) {
      console.error('Failed to send message:', error);
      const errorText = error?.payload ? JSON.stringify(error.payload) : (error?.body || error?.message || 'Unknown error');
      setResponse(prevResponse => [...prevResponse, {
        role: 'assistant',
        data: { type: 'error', text: errorText }
      }]);
      setMessage('');
      setIsLoading(false);
    }
  }, [message, accessToken, uuid, adjustTextareaHeight, StopListening]);

  const handleSingleChoiceSelect = useCallback((option, chatId) => {
    // Add the selected option as a user message to the response array
    const userMessage = {
      role: 'user',
      data: {
        type: 'text',
        text: option.label || option.value,
      },
    };
    setResponse(prevResponse => [...prevResponse, userMessage]);

    setResponse(prevResponse => {
      return prevResponse.map((chat, chatIndex) => {
        const isCorrectChat = chat.id === chatId ||
          chat.id === `chat-${chatId}` ||
          chatIndex === chatId ||
          chat.id === `chat-${chatIndex}`;

        if (isCorrectChat) {
          const updatedData = Array.isArray(chat.data)
            ? chat.data.map(msg => {
              if (msg.type === 'single-choice') {
                return {
                  ...msg,
                  options: msg.options.map(opt => ({
                    ...opt,
                    selected: opt.value === option.value
                  }))
                };
              }
              return msg;
            })
            : chat.data.type === 'single-choice'
              ? {
                ...chat.data,
                options: chat.data.options.map(opt => ({
                  ...opt,
                  selected: opt.value === option.value
                }))
              }
              : chat.data;

          return {
            ...chat,
            data: updatedData
          };
        }
        return chat;
      });
    });

    handleSendMessage(option.value, true, option.message_id);
  }, [handleSendMessage]);

  const handleLCPCardClick = useCallback(async (item, userData) => {
    try {
      console.log('LCP Card clicked:', item);

      // Use existing loading state
      setIsLoading(true);

      // Make API call
      const result = await sendLCPCallbackRequest(accessToken, userData?.mobileNumber);

      // Add success message
      setResponse(prevResponse => [...prevResponse, {
        role: 'assistant',
        data: {
          type: 'text',
          text: content[langCode].thanksForRequestingCallback
        }
      }]);

      setIsLoading(false);
      console.log('LCP callback request successful:', result);
    } catch (error) {
      console.error('LCP callback request failed:', error);

      // Add error message
      setResponse(prevResponse => [...prevResponse, {
        role: 'assistant',
        data: {
          type: 'error',
          text: content[langCode].errorProcessingRequest
        }
      }]);

      setIsLoading(false);
    }
  }, [accessToken, langCode]);

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        console.log("📨 Received message from React Native:", event.data);

        let messageData;
        if (typeof event.data === "string") {
          try {
            messageData = JSON.parse(event.data);
          } catch (e) {
            console.warn("Failed to parse message data as JSON:", e);
            return;
          }
        } else {
          messageData = event.data;
        }

        console.log("📨 Parsed message data:", messageData);

        // Handle React Native speech-to-text messages
        if (messageData.type === 'speech_partial') {
          console.log("🎤 React Native partial speech:", messageData.text);
          const nextValue = buildSpeechText(messageData.text || '');
          setMessage(nextValue);
          return;
        }

        // if (messageData.type === 'speech_final') {
        //   console.log("🎤 React Native final speech:", messageData.text);
        //   const nextValue = buildSpeechText(messageData.text || '');
        //   speechBaseTextRef.current = nextValue;
        //   setMessage(nextValue);
        //   return;
        // }

        if (messageData.type === 'speech_stopped') {
          const stoppedManually = Boolean(messageData.manual);
          console.log("🛑 React Native speech stopped", stoppedManually ? '(manual)' : '(auto)');
          setIsRecording(false);
          releaseMicLockWithDelay();
          setIsFromSpeech(false);
          const currentMessageValue = (latestMessageRef.current || '').trim();
          speechBaseTextRef.current = currentMessageValue;
          if (stoppedManually) {
            setMessage(currentMessageValue);
          }
          return;
        }

        if (messageData.type === 'speech_error') {
          console.warn("🎤 Speech recognition error:", messageData.message);
          setIsRecording(false);
          releaseMicLockWithDelay();
          setIsFromSpeech(false);
          const speechErrorPrompt = content?.[langCode]?.speechErrorPrompt || content?.en?.speechErrorPrompt;
          if (speechErrorPrompt) {
            Toast.error(speechErrorPrompt);
          }
          return;
        }

        if (messageData.type === 'START_WEB_VIEW') {
          // Extract profile data if it exists
          const profileData = messageData?.data?.profileData;
          if (profileData) {
            console.log("👤 Received profile data:", profileData);
            setUuid(profileData.uuid || "");
            setAccessToken(profileData.accessToken || "");
            localStorage.setItem("accesstoken", profileData?.accessToken);
            localStorage.setItem("secondary_uuid", profileData?.uuid);
            localStorage.setItem("languageSelection", profileData.language?.toUpperCase());
            localStorage.setItem("mobileNumber", profileData?.mobile);
            setUserData(profileData);
            localStorage.setItem(
              "profileDetails",
              JSON.stringify({
                full_name: profileData?.firstName,
                age: profileData?.age,
              })
            );
            sessionStorage.setItem("source_from", "app");
            setLangCode(profileData.language?.toLowerCase() === 'hi' ? 'hi' : 'en');
            profileRetryRef.current = 0; // reset retries on success
          } else {
            // No profileData received - request again with limited retries
            if (profileRetryRef.current < 3) {
              profileRetryRef.current += 1;
              requestProfileData();
              setTimeout(() => {
                requestProfileData();
              }, 1000);
            }
          }
        }
      } catch (error) {
        console.warn("Error processing message:", error);
      }
    };

    // Add event listeners
    if (document.addEventListener) {
      document.addEventListener("message", handleMessage, false);
    } else if (document.attachEvent) {
      document.attachEvent("onmessage", handleMessage);
    }

    if (window.addEventListener) {
      window.addEventListener("message", handleMessage, false);
    } else if (window.attachEvent) {
      window.attachEvent("onmessage", handleMessage);
    }

    // Cleanup function
    return () => {
      if (document.removeEventListener) {
        document.removeEventListener("message", handleMessage);
      } else if (document.detachEvent) {
        document.detachEvent("onmessage", handleMessage);
      }

      if (window.removeEventListener) {
        window.removeEventListener("message", handleMessage);
      } else if (window.detachEvent) {
        window.detachEvent("onmessage", handleMessage);
      }
    };
  }, [requestProfileData, buildSpeechText, langCode, releaseMicLockWithDelay]);

  // Proactively request profile data if token not present
  useEffect(() => {
    if (!accessToken) {
      requestProfileData();
    }
  }, [accessToken, requestProfileData]);

  const handleInitialMessage = useCallback(async (resetConversation = false) => {
    if (!accessToken) return;

    // Prevent multiple simultaneous calls
    if (isLoading) return;

    setIsLoading(true);
    try {
      const result = await sendMessageToChatBot(accessToken);
      if (result?.data) {
        if (resetConversation) {
          // Reset conversation and show only initial message
          setResponse([result.data]);
        } else {
          setResponse(prevResponse => [...prevResponse, result.data]);
        }
        setIsLoading(false);
      } else {
        setResponse(prevResponse => resetConversation ? [{
          role: 'assistant',
          data: { type: 'error', text: JSON.stringify(result) }
        }] : [...prevResponse, {
          role: 'assistant',
          data: { type: 'error', text: JSON.stringify(result) }
        }]);
        setIsLoading(false);
      }
    } catch (error) {
      console.error('Failed to send initial message:', error);
      const errorText = error?.payload ? JSON.stringify(error.payload) : (error?.body || error?.message || 'Unknown error');
      setResponse(prevResponse => resetConversation ? [{
        role: 'assistant',
        data: { type: 'error', text: errorText }
      }] : [...prevResponse, {
        role: 'assistant',
        data: { type: 'error', text: errorText }
      }]);
      setIsLoading(false);
    }
  }, [accessToken, isLoading]);

  const shouldTriggerInitialMessage = () => sessionStorage.getItem('triggerInitialMessage') === 'true';
  const clearTriggerInitialMessageFlag = () => sessionStorage.removeItem('triggerInitialMessage');

  useEffect(() => {
    if (accessToken && !initialMessageTriggeredRef.current) {
      handleInitialMessage();
      initialMessageTriggeredRef.current = true;
    }
  }, [accessToken, handleInitialMessage]);

  useEffect(() => {
    let reactNativePayload = { type: "HIDE_BACK_ARROW", key: 205 };
    if (window?.ReactNativeWebView) {
      window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
    }
  }, []);

  // Handle TTS for voice responses
  useEffect(() => {
    if (lastInputSource === 'voice' && response && response.length > 0) {
      const lastMessage = response[response.length - 1];
      if (lastMessage.role === 'assistant' && lastMessage.input_source === 'voice') {
        const textToSpeak = convertLastMessageToText([lastMessage]);
        if (textToSpeak) {
          // Clear any existing timeout
          if (ttsTimeoutRef.current) {
            clearTimeout(ttsTimeoutRef.current);
          }

          // Send TTS message to app with a small delay to ensure message is processed
          ttsTimeoutRef.current = setTimeout(() => {
            sendTTSMessage(textToSpeak, 'speak');
          }, 100);
        }
      }
    }
  }, [response, lastInputSource]);

  // Cleanup TTS on unmount
  useEffect(() => {
    return () => {
      if (ttsTimeoutRef.current) {
        clearTimeout(ttsTimeoutRef.current);
      }
      // Stop any ongoing TTS when component unmounts
      sendTTSMessage('', 'stop');
      if (micUnlockTimeoutRef.current) {
        clearTimeout(micUnlockTimeoutRef.current);
      }
    };
  }, []);

  // Adjust textarea height when message changes
  useEffect(() => {
    adjustTextareaHeight();
  }, [message, adjustTextareaHeight]);

  useEffect(() => {
    latestMessageRef.current = message || '';
  }, [message]);

  // Listen for screen visibility changes and re-trigger initial message when screen comes back
  useEffect(() => {
    const handleVisibilityChange = () => {
      const isVisible = !document.hidden;

      // If screen becomes visible and we were hidden before
      if (isVisible && !isVisibleRef.current) {
        console.log('Screen became visible, checking if we need to re-trigger the initial message');
        setTimeout(() => {
          if (accessToken && initialMessageTriggeredRef.current && !isLoading && shouldTriggerInitialMessage()) {
            handleInitialMessage(false); // Don't reset conversation, just add new initial message
            clearTriggerInitialMessageFlag();
          }
        }, 300);
      }

      isVisibleRef.current = isVisible;
    };

    const handleFocus = () => {
      // When window regains focus, re-trigger initial message
      console.log('Window focused, checking if we should re-trigger initial message');
      if (accessToken && initialMessageTriggeredRef.current && !isLoading && !isVisibleRef.current && shouldTriggerInitialMessage()) {
        console.log('Window focused, checking if we need to re-trigger the initial message');
        setTimeout(() => {
          handleInitialMessage(false); // Don't reset conversation, just add new initial message
          clearTriggerInitialMessageFlag();
        }, 300);
      }
      isVisibleRef.current = true;
    };

    const handleBlur = () => {
      // When window loses focus, mark as hidden
      console.log('Window blurred');
      isVisibleRef.current = false;
    };

    // Listen for visibility changes
    document.addEventListener('visibilitychange', handleVisibilityChange);

    // Listen for window focus and blur events (useful for webview scenarios)
    window.addEventListener('focus', handleFocus);
    window.addEventListener('blur', handleBlur);

    // Also listen for messages from React Native indicating screen is active
    const handleNativeMessage = (event) => {
      try {
        let messageData;
        if (typeof event.data === "string") {
          try {
            messageData = JSON.parse(event.data);
          } catch (e) {
            return;
          }
        } else {
          messageData = event.data;
        }

        // Listen for screen active event from React Native
        if (messageData.type === 'SCREEN_ACTIVE' || messageData.type === 'WEBVIEW_ACTIVE') {
          console.log('Screen active message received, re-triggering initial message');
          if (accessToken && initialMessageTriggeredRef.current && !isLoading) {
            setTimeout(() => {
              handleInitialMessage(false);
            }, 300);
          }
        }
      } catch (error) {
        console.warn("Error processing screen active message:", error);
      }
    };

    // Add listener for React Native messages (in addition to existing message handler)
    if (window.addEventListener) {
      window.addEventListener("message", handleNativeMessage, false);
    }

    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      window.removeEventListener('focus', handleFocus);
      window.removeEventListener('blur', handleBlur);
      if (window.removeEventListener) {
        window.removeEventListener("message", handleNativeMessage);
      }
    };
  }, [accessToken, isLoading, handleInitialMessage]);

  const handleBackToHome = () => {
    let reactNativePayload = { type: "HIDE_INTERNAL_PWA", key: 207 };
    if (window?.ReactNativeWebView) {
      window?.ReactNativeWebView?.postMessage(JSON.stringify(reactNativePayload));
    }
  };

  return (
    <section className='bg-background'>
      <div className='bg-background flex items-center gap-2 py-3 px-4 shadow-md fixed top-0 left-0 right-0 z-50'>
        <button className='w-[45px] h-10 rounded-2xl flex items-center justify-center shadow-md bg-gradient-to-br from-[#7A7A7A4D] to-white' onClick={handleBackToHome}>
          <span className='flex items-center justify-center w-[44px] h-[39px] bg-white rounded-2xl'>
            <svg width="10" height="14" viewBox="0 0 10 14" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M7.97384 1.5L1.5 6.70009L7.97384 12.2511" stroke="black" stroke-width="3" stroke-linecap="round" stroke-linejoin="round" />
            </svg>
          </span>
        </button>
        <div className='flex items-center gap-2'>
          <span className='w-10 h-10 bg-accent-foreground rounded-full block'>
            <img src={Assistant} alt="assistant" className='w-10 h-10 aspect-square object-cover rounded-full' />
          </span>
          <div>
            <h3 className='text-sm font-medium'>Ask Breasy</h3>
          </div>
        </div>
      </div>
      <Chats response={response} isLoading={isLoading} onSingleChoiceSelect={handleSingleChoiceSelect} onLCPCardClick={handleLCPCardClick} userData={userData} lastInputSource={lastInputSource} langCode={langCode} />
      <div className='fixed bottom-0 left-0 z-50 bg-white w-full custom-shadow'>
        <div className='px-4 mt-3 mb-2 relative'>
          <div className='w-[calc(100%-64px)] relative'>
            <textarea
              ref={textareaRef}
              value={message}
              disabled={isLoading}
              onFocus={() => {
                setIsFocused(true);
              }}
              onBlur={() => {
                setIsFocused(false);
              }}
              onChange={(e) => {
                setMessage(e.target.value);
                if (isFromSpeech) {
                  setIsFromSpeech(false);
                }
                adjustTextareaHeight();
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  handleSendMessage(message, false, null, isFromSpeech ? 'voice' : 'text');
                }
              }}
              className='w-full px-3 py-2.5 pr-8 rounded-lg bg-[#F4F4F4] text-base focus-visible:outline-none resize-none overflow-hidden text-left'
              style={{ minHeight: '50px', maxHeight: '92px', lineHeight: '1.25', alignItems: 'center' }}
            />
            {!message && !isFocused && (
              <div className='absolute top-5 pointer-events-none pl-3 leading-none'>
                <span className='text-xs text-gray-400'>
                  {isRecording ? content[langCode].breasyIsListening : content[langCode].type}
                </span>
              </div>
            )}
            {message && message.trim().length > 0 && (
              <button
                disabled={isLoading || (isMicLocked && !isRecording)}
                onClick={() => isRecording ? StopListening() : StartListening()}
                className='absolute right-2 bottom-5 disabled:opacity-50 disabled:cursor-not-allowed'
              >
                {isRecording ? <img src={MicOn} alt="Mic On" className='w-full h-full' /> : <img src={MicOff} alt="Mic Off" className='w-full h-full' />}
              </button>
            )}
          </div>
          <div className='absolute right-4 bottom-1'>
            {
              message && message.trim().length > 0 ? (
                <button
                  disabled={isLoading || !message.trim()}
                  onClick={() => handleSendMessage(message, false, null, isFromSpeech ? 'voice' : 'text')}
                  className='h-14 w-14 flex items-center justify-center cursor-pointer'
                >
                  <img src={Send} alt="Send" className='w-full h-full' />
                </button>
              ) : (
                <button
                  disabled={isLoading || (isMicLocked && !isRecording)}
                  onClick={() => isRecording ? StopListening() : StartListening()}
                  className='bg-accent-foreground text-white rounded-full h-14 w-14 flex items-center justify-center disabled:cursor-not-allowed'
                >
                  {isLoading ? <img src={MicDisabled} alt="Mic Disabled" className='w-full h-full' /> : (isRecording ? <img src={MicOnFill} alt="Mic On" className='w-full h-full' /> : <img src={MicOffFill} alt="Mic Off" className='w-full h-full' />)}
                </button>)
            }
          </div>
        </div>
        <p className='text-xs text-[#66666680] px-6 py-2.5 bg-[#F8F8F8]'>
          <span className='font-medium text-[#666666]'>Disclaimer:</span> Responses are AI-generated and may contain errors. Always seek medical guidance from a doctor.
        </p>
      </div>
    </section >
  )
}

export default ChatBot